import React from 'react';
// import { dummyData } from './utils/dummyData';
import { columnDefinitions, defaultColDef } from './_utils/definitions-config';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';
import { getAllAbcatExtensionStudent } from '../../services/apiService';

const pageSize = 10;

const ManageABCAT = () => {
  const getServerSideDatasource = () => {
    return {
      getRows: (params) => {
        const body = {
          filters: {
            email: params.request?.filterModel?.email?.filter || null,
            noOfExtension:
              params.request?.filterModel?.numberOfExtension?.filter ?? null,
          },
          pagination: {
            start: params.request.startRow,
            end: params.request.endRow,
          },
        };

        try {
          // call the api here to fetch and set data to the column.
          getAllAbcatExtensionStudent(body).then((response) => {
            params.successCallback(
              response?.data || [],
              response?.pagination?.totalCount || 0
            );
          });
        } catch (error) {
          console.error(error);
          params.failCallback();
          toast.error('Failed to fetch data');
        }
      },
    };
  };

  const onGridReady = React.useCallback((params) => {
    const datasource = getServerSideDatasource();
    params?.api?.setServerSideDatasource(datasource);
  }, []);

  const onFilterChanged = async (props) => {
    onGridReady();
  };

  return (
    <div>
      <div className='bg-white py-8 px-6'>
        <div className='flex items-center gap-2 '>
          <div className='text-2xl font-semibold'>AB-CAT</div>
        </div>
      </div>
      <div className='ag-theme-alpine z-50' style={{ width: '100%' }}>
        <AgGridReact
          columnDefs={columnDefinitions}
          onFilterChanged={onFilterChanged}
                    defaultColDef={defaultColDef}
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          onGridReady={onGridReady}
          rowHeight={60}
          domLayout='autoHeight'
          rowModelType='serverSide'
          serverSideStoreType='partial'
          animateRows={true}
          serverSideInfiniteScroll={true}
          pagination={true}
          suppressPaginationPanel={false}
          paginationPageSize={pageSize}
          cacheBlockSize={pageSize}
        />
      </div>
    </div>
  );
};

export default ManageABCAT;
